export default __webpack_public_path__ + "static/media/live_lecture_thumbnail.73503c98.png";